import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import AnimatedText from "../components/AnimatedText";
import Seo from "../components/Seo";

const StartupAndBusinessSetup = () => {
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="info-page-wrapper font-inter">
      <Seo
        title="Startup & Business Setup — Legal Platform"
        description="Legal foundation for entrepreneurs, startup scaling, and company formation services."
        canonicalPath="/startup-business-setup"
        image="/favicon.png"
      />
      <Header />
      <Breadcrumbs />
      <main className="info-page-section py-5">
        <div
          className="info-page-main-card"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="home-hero-title text-center"><AnimatedText text="Startup & Business Setup" /></h1>
          <div className="home-hero-text text-center">
            <AnimatedText text="Launch your business on a solid legal foundation. Our verified lawyers provide comprehensive setup services for startups and established enterprises, handling everything from company formation and licensing to shareholder agreements and regulatory compliance." />
          </div>
        </div>

        <div className="info-page-list">
          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Company Formation" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Get expert help choosing the right legal structure for your business. We assist with incorporation, local licensing requirements, and registration with relevant authorities to ensure your business is legally operational from day one." />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Shareholder Agreements" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Define clear relationships between business partners. Our legal experts draft comprehensive shareholder and partnership agreements that cover equity distribution, voting rights, and dispute resolution mechanisms to protect all stakeholders." />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Scaling & Compliance" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Ensure your business remains compliant as it grows. We provide ongoing legal support for regulatory updates, employment law, data protection, and contract management to help your startup scale safely and efficiently." />
            </div>
          </div>
        </div>
      </main>
      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
      <Footer />
    </div>
  );
};

export default StartupAndBusinessSetup;
